export default "__VITE_ASSET___6wONFiW__"